// @flow
import { css } from '@emotion/core';

// eslint-disable-next-line import/prefer-default-export
export const gridSpan = (
  orientation: 'column' | 'row',
  start: number,
  span: number
) => css`
  -ms-grid-${orientation}: ${start};
  -ms-grid-${orientation}-span: ${span};
  grid-${orientation}-start: ${start};
  grid-${orientation}-end: ${start + span};
`;
